module.exports = __webpack_public_path__ + "media/images/top/test-03c2b12d964664e6c02b32c112cd22c3.jpg";